<script>
    import { orderBy, sumBy } from 'lodash-es';

    export default {
        computed: {
            streamMonthlyCost() {
                let streamMonthlyCost = 0;

                if (this.selectedStreamArticles.length > 0) {
                    let selectedStreamPackages = this.selectedStreamArticles;
                    selectedStreamPackages = this.sortAndTransformStreamingPackages(
                        selectedStreamPackages
                    );

                    // If we have a streaming package that is included, we know we should reset
                    // the price of the first package that happens to be "included".
                    // We have to make sure that we remove the first items price that is included
                    // since if we only check the first item we won't be sure that it's the one that's
                    // included and free for the user.
                    if (selectedStreamPackages.filter((streamPack) => streamPack.included).length > 0) {
                        let gaveDiscount = false;

                        selectedStreamPackages.map((selectedStreamPackage, index) => {
                            // Only the most expensive one will be free if multiple included
                            // packages are selected
                            if (selectedStreamPackage.included && ! gaveDiscount) {
                                selectedStreamPackage.price = 0;
                                gaveDiscount = true;
                            }

                            return selectedStreamPackage;
                        });
                    }

                    streamMonthlyCost = sumBy(selectedStreamPackages, (pack) => pack.price);
                }

                return streamMonthlyCost;
            },
        },
        methods: {
            sortAndTransformStreamingPackages(packages) {
                return orderBy(packages.map((streamPackage) => {
                    return {
                        id: streamPackage.article_id,
                        included: streamPackage.is_included,
                        price: streamPackage.monthly_price,
                        article_id: streamPackage.article_id,
                        article_class: streamPackage.article_class,
                        name: streamPackage.name,
                    };
                }), ['price', 'name'], 'desc');
            },
            streamIsIncluded(stream) {
                if (this.selectedStreamArticles.length < 1) {
                    return false;
                }

                const includedStreams = this.sortAndTransformStreamingPackages(
                    this.selectedStreamArticles
                );

                return includedStreams[0]['article_id'] === stream.article_id
                    && includedStreams[0]['included'];
            },
        },
    };
</script>
